import React, { createContext } from 'react';
import PropTypes from 'prop-types';

export const KeyboardContext = createContext();

class KeyboardContextProvider extends React.Component {
    state = {
        activeInput: null
    };

    setActiveInput = (activeInput) => this.setState({ activeInput });

    render() {
        return (
            <KeyboardContext.Provider value={{ ...this.state, setActiveInput: this.setActiveInput }}>
                {this.props.children}
            </KeyboardContext.Provider>
        );
    }
}

KeyboardContextProvider.propTypes = {
    children: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default KeyboardContextProvider;
